import { render } from "./SocialCause.vue?vue&type=template&id=5bf3da5a&scoped=true"
import script from "./SocialCause.vue?vue&type=script&lang=js"
export * from "./SocialCause.vue?vue&type=script&lang=js"

import "@/Common/Styles/socialCause.scss?vue&type=style&index=0&id=5bf3da5a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf3da5a"]])

export default __exports__